import { gql } from '@apollo/client';

export const GET_STOCK_LOCATIONS = gql`
  query GetStockLocations($portfolioId: ID!) {
    stockLocations(portfolioId: $portfolioId) {
      id
      name
      description
      createdAt
      updatedAt
    }
  }
`;

export const GET_STOCK_LOCATION_BALANCES = gql`
  query GetStockLocationBalances($stockId: ID!, $portfolioId: ID!) {
    stockPosition(stockId: $stockId, portfolioId: $portfolioId) {
      id
      holdingsAmount
      locationBalances {
        locationId
        name
        quantity
      }
    }
  }
`;
